import React, {
    useState,
    useEffect,
    useRef
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _ from 'lodash';
import { ComponentPropTypes } from '@jutro/prop-types';
import styles from './MLAccordion.module.scss';

import { Accordion, AccordionCard } from '@jutro/legacy/components';

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

const cx = classNames.bind(styles)

function MLAccordion(props) {
    const { accordionStates, className, ...rest } = props
    const [isCollapsing, setIsCollapsing] = useState(false);
    const prevAccordionStates = usePrevious(props.accordionStates)

    const newClassNames = cx(className, { 'ml-accordion': !isCollapsing })

    const endCollapsing = () => setIsCollapsing(false)

    useEffect(() => {
        const diffArray = _.differenceWith(accordionStates, prevAccordionStates, _.isEqual);
        if (diffArray) {
            setIsCollapsing(true)
            setTimeout(endCollapsing, 700)
        }
    }, [accordionStates, prevAccordionStates])


    return <Accordion {...rest} accordionStates={accordionStates} className={newClassNames} />
}

MLAccordion.propTypes = {
    id: PropTypes.string,
    accordionStates: PropTypes.array,
    boldFont: PropTypes.bool,
    className: PropTypes.string,
    children: ComponentPropTypes.childOfComponentType(AccordionCard),
    closeOthers: PropTypes.bool,
    defaultOpenedId: PropTypes.string,
    disabled: PropTypes.bool,
    showFrame: PropTypes.bool,
    onUpdateAccordionStates: PropTypes.func,
}

export default MLAccordion